module.exports = __webpack_public_path__ + "img/lamp-street-solid-full.1d9056c0.svg";